import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { LcsCallStatePipeModule } from '@lcs/shared/call-state-pipe';
import { LcsLoadingOverlayModule } from '@lcs/shared/loading-overlay';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { EntitySelectModule } from 'src/app/common-components/entity-select/entity-select.module';
import * as fromAccountDetails from '../account-details/state/account-detail.reducer';
import { AddExistingPromptModule } from '../add-existing-prompt/add-existing-prompt.module';
import { AddFindMeFollowMeStepModule } from '../add-find-me-follow-me-step/add-find-me-follow-me-step.module';
import { AddPromptModule } from '../add-prompt/add-prompt.module';
import { AddTimeBasedRouteModule } from '../add-time-based-route/add-time-based-route.module';
import { ExtensionDetailModule } from '../extension-details/extension-detail.module';
import { AddExtensionComponent } from './containers/add-extension.component';
import { AddExtensionEffects } from './state/add-extension.effects';
import * as fromAddExtension from './state/add-extension.reducer';
import { AddExtensionViewComponent } from './views/add-extension-view.component';

@NgModule({
   declarations: [AddExtensionComponent, AddExtensionViewComponent],
   imports: [
      CommonModule,
      FormsModule,
      MatFormFieldModule,
      ReactiveFormsModule,
      MatCheckboxModule,
      MatInputModule,
      MatButtonModule,
      MatTooltipModule,
      MatSelectModule,
      MatDialogModule,
      LcsLoadingOverlayModule,
      LcsCallStatePipeModule,
      MatIconModule,
      AddExistingPromptModule,
      AddTimeBasedRouteModule,
      AddFindMeFollowMeStepModule,
      AddPromptModule,
      EntitySelectModule,
      StoreModule.forFeature(fromAddExtension.addExtensionFeatureKey, fromAddExtension.reducer),
      StoreModule.forFeature(fromAccountDetails.accountDetailFeatureKey, fromAccountDetails.reducer),
      EffectsModule.forFeature([AddExtensionEffects]),
      ExtensionDetailModule,
   ],
})
export class AddExtensionModule {}
